import { referralRewardRuleSchema } from "./referral-reward-rule";
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createReferralRewardRuleSchema = referralRewardRuleSchema
  .pick({
    quotas: true,
    operator: true,
    amount: true,
  })
  .extend({
    rateId: z.string().optional(),
    type: z.enum(["money", "souscription"]).optional(),
    is_active: z.boolean().optional(),
  });

export class CreateReferralRewardRuleDto extends createZodDto(createReferralRewardRuleSchema) {}
